import { PageHero } from "../components/PageHero";
import { Reveal } from "../lib/motion";
import { INSIGHTS } from "../lib/data";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Insights() {
  const [featured, ...rest] = INSIGHTS;
  return (
    <>
      <PageHero
        testid="insights-hero"
        overline="Insights"
        title="Perspectives on AI, engineering and delivery."
        subtitle="Executive thinking on AI-native engineering, Extended PODs, delivery discipline and turning AI pilots into scalable capability."
      />
      <section className="bg-background py-24">
        <div className="container-x">
          <Reveal>
            <Link
              to={`/insights/${featured.slug}`}
              data-testid={`insight-${featured.slug}`}
              className="group grid gap-8 overflow-hidden rounded-2xl border border-border bg-navy text-white transition-all duration-300 hover:border-accent/50 md:grid-cols-2 grain"
            >
              <div className="relative min-h-[280px] overflow-hidden">
                <img src={featured.hero} alt={featured.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-navy/40" />
              </div>
              <div className="flex flex-col justify-center p-8 md:p-12">
                <p className="font-mono text-[11px] uppercase tracking-widest text-accent">{featured.category} · Featured</p>
                <h2 className="mt-4 text-3xl font-semibold tracking-tighter">{featured.title}</h2>
                <p className="mt-4 leading-relaxed text-white/60">{featured.excerpt}</p>
                <div className="mt-6 flex items-center gap-4 text-sm text-white/50">
                  <span>{featured.date}</span><span>·</span><span>{featured.read} read</span>
                </div>
                <span className="mt-4 inline-flex items-center gap-2 font-semibold text-accent">
                  Read article <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>

          <div className="mt-6 grid gap-5 md:grid-cols-3">
            {rest.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.08}>
                <Link
                  to={`/insights/${a.slug}`}
                  data-testid={`insight-${a.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-2xl border border-border bg-background transition-all duration-300 hover:-translate-y-1 hover:border-accent/50 hover:shadow-[0_18px_50px_rgba(18,60,82,0.1)]"
                >
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img src={a.hero} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="flex flex-1 flex-col p-8">
                    <p className="font-mono text-[11px] uppercase tracking-widest text-accent">{a.category}</p>
                    <h3 className="mt-4 text-xl font-semibold tracking-tight">{a.title}</h3>
                    <p className="mt-3 flex-1 leading-relaxed text-muted-foreground">{a.excerpt}</p>
                    <div className="mt-6 flex items-center gap-3 text-xs text-muted-foreground">
                      <span>{a.date}</span><span>·</span><span>{a.read} read</span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
